import { render, staticRenderFns } from "./BaseCostForm.vue?vue&type=template&id=1c21570b&"
import script from "./BaseCostForm.vue?vue&type=script&lang=js&"
export * from "./BaseCostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports